module.exports = __webpack_public_path__ + "img/MottoCenter-D-TOOLS-Mail.95cd09e8.png";